// components/RequestDemoModal.js

import React from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Demo from "../../Demo"; // Adjust path if needed

const RequestDemoModal = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="body">
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          zIndex: 10,
          color: "#000",
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Demo showSocialCause={false} />
      </DialogContent>
    </Dialog>
  );
};

export default RequestDemoModal;
